
// Configuración de entorno

// Cambia esta URL según dónde corras el backend.
// 1) En local (Node levantado con "node index.js"):
//    const MAIL_API_URL = "http://localhost:3000/sendEmail";
// 2) En producción :
//    const MAIL_API_URL = "https://tu-servicio-publico/sendEmail";

//const LOCAL_URL = "http://localhost:3000/sendEmail";
const PROD_URL = "https://sendemail-aaetoibmfa-uc.a.run.app"; // <-- reemplazar cuando subas
const MAIL_API_URL = PROD_URL;


export async function sendExternalEmail({ recipients, subject, text }) {
  try {
    const payload = {
      //from: smtp.smtp_correo || smtp.correo || "",
      from: "pruebasrrhh@lyseis.es",
      to: recipients || [],
      subject: subject || "",
      text: text || "",
    };

    const r = await fetch(`${MAIL_API_URL}/sendEmail`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
      body: JSON.stringify(payload),
    });

    return await r.json();
  } catch (e) {
    console.error("Error al enviar email:", e);
    return { ok: false, error: "fetch-failed" };
  }
}

